import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import HeaderDuaContent from "../pages/Features/header-dua-content";
import HeaderDuaJumbotron from "../pages/Features/header-dua-jumbotron";

export default function FeatureHeaderDua() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <NavbarHome />
      <HeaderDuaJumbotron />
      <HeaderDuaContent />
      <Footer />
    </>
  );
}
